<section class="scr-page scr-page--compact">
  <div class="scr-card">
    <tp-page-header variant="toolbar" title="Franquicias" [subtitle]="franchises.length + ' franquicias'">
      <button mat-flat-button actions class="scr-btn-primary" type="button" (click)="dialogAction(FranchiseModalComponent)">
        <mat-icon>add</mat-icon>
        Nueva franquicia
      </button>
    </tp-page-header>

  <div class="table-container scr-table-scroll">
    <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)">
      <ng-container matColumnDef="franchise">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="name" sortActionDescription="Sort by franchise">
          <span class="truncate">Franquicia</span>
        </th>
        <td mat-cell *matCellDef="let element">
          <span class="data">{{ element.name }}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="companyName">
        <th mat-header-cell *matHeaderCellDef class="align" mat-sort-header sortActionDescription="Sort by companyName">
          <span class="truncate">Razón social</span>
        </th>
        <td mat-cell *matCellDef="let element">
          <span class="data">{{ element.companyName }}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="city">
        <th mat-header-cell *matHeaderCellDef class="align">
          <span class="truncate">Localidad</span>
        </th>
        <td mat-cell *matCellDef="let element">
          <span class="data">{{ element.city }}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="address">
        <th mat-header-cell *matHeaderCellDef class="align">
          <span class="truncate">Dirección</span>
        </th>
        <td mat-cell *matCellDef="let element">
          <span class="data">{{ element.address }}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="menu">
        <th mat-header-cell *matHeaderCellDef class="align">
          <span class="truncate"></span>
        </th>
        <td mat-cell class="menu" *matCellDef="let element">
          <app-icon-menu-button [menu]="menu" label="Más opciones"></app-icon-menu-button>
          <mat-menu #menu="matMenu">
            <button class="menu-button" mat-menu-item (click)="dialogAction(PointSaleComponent, element)">
              Añadir punto de venta
            </button>
            <button class="menu-button" mat-menu-item (click)="goPointSale(element)">
              Ver puntos de venta
            </button>
            <button class="menu-button" mat-menu-item (click)="goFranchiseZone(element)">
              Zona de franquicia
            </button>
            <button class="menu-button" mat-menu-item (click)="dialogAction(FranchiseModalComponent, element)">
              Editar Franquicia
            </button>
            <button class="menu-button" mat-menu-item (click)="deleteFranchise(element.id)">
              Eliminar Franquicia
            </button>
          </mat-menu>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="goFranchise(row)"
        (keydown)="onRowKeydown($event, row)" tabindex="0" [ngClass]="{
          'last-row': row === dataSource.data[dataSource.data.length - 1]
        }"></tr>
    </table>
    @if (franchises.length < 1) {
      <tp-empty-state icon="storefront" title="No hay franquicias" message="Cuando se registre una franquicia la vas a ver acá."></tp-empty-state>
    }
  </div>
  <div class="scr-footer">
    <span class="scr-count">{{ dataSource.data.length }} resultados</span>
    <mat-paginator [pageSizeOptions]="[10, 20, 30]" aria-label="Select page of franchises"></mat-paginator>
  </div>
</div>
</section>